import { createContext } from 'react';
import { IApiService } from '../../api/IApiService';

export type ApiContextType = {
    apiService: IApiService;
    companyInfoId: string;
    setCompanyInfoId: (id: string) => void;
};

const ApiServiceContext = createContext<ApiContextType>({} as ApiContextType);

export default ApiServiceContext;
